module.exports = __webpack_public_path__ + "static/nuerex_logo-a9129850064a5021c35ed533e7ada1e7.png";